export const extractJrestIdFromHref = (href: string) => {
  const id = href.match(/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i)
  return id ? id[1] : null
}
